import { render, staticRenderFns } from "./PageItemClaims.vue?vue&type=template&id=2a3295a2&scoped=true"
import script from "./PageItemClaims.vue?vue&type=script&lang=ts"
export * from "./PageItemClaims.vue?vue&type=script&lang=ts"
import style0 from "./PageItemClaims.vue?vue&type=style&index=0&id=2a3295a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3295a2",
  null
  
)

export default component.exports